// Footer configurations for each page

export const contactPageFooter = {
  title: 'Get in Touch',
  subtitle: 'We\'re here to help',
  sections: [
    {
      title: 'Contact',
      items: [
        { label: 'Email Us', href: 'mailto:info@mernaki.de' },
        { label: 'Help Center', to: '/help' },
        { label: 'FAQ', to: '/faq' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
        { label: 'Careers', to: '/careers' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Documentation', to: '/docs' },
        { label: 'Status', to: '/status' },
      ]
    }
  ]
}

export const productsPageFooter = {
  title: 'Our Products',
  subtitle: 'Explore our solutions',
  sections: [
    {
      title: 'Products',
      items: [
        { label: 'Software', disabled: true },
        { label: 'Hardware', disabled: true },
        { label: 'Services', to: '/#services' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
        { label: 'Careers', to: '/careers' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'Contact', to: '/contact' },
        { label: 'FAQ', to: '/faq' },
      ]
    }
  ]
}

export const aboutPageFooter = {
  title: 'About Mernaki',
  subtitle: 'Learn more about us',
  sections: [
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
        { label: 'Careers', to: '/careers' },
        { label: 'Partners', to: '/partners' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'Contact', to: '/contact' },
        { label: 'FAQ', to: '/faq' },
      ]
    },
    {
      title: 'Legal',
      items: [
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Terms of Service', to: '/terms-of-service' },
        { label: 'Impressum', to: '/impressum' },
      ]
    }
  ]
}

export const careersPageFooter = {
  title: 'Join Our Team',
  subtitle: 'Build the future with us',
  sections: [
    {
      title: 'Opportunities',
      items: [
        { label: 'Open Positions', to: '/careers#positions' },
        { label: 'Internships', to: '/careers#internships' },
        { label: 'Culture', to: '/about#culture' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
        { label: 'Partners', to: '/partners' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Contact', to: '/contact' },
        { label: 'Help Center', to: '/help' },
      ]
    }
  ]
}

export const partnersPageFooter = {
  title: 'Partner With Us',
  subtitle: 'Grow together',
  sections: [
    {
      title: 'Partnership',
      items: [
        { label: 'Partner Program', to: '/partners' },
        { label: 'Apply Now', to: '/partnerships' },
        { label: 'Benefits', to: '/partners#benefits' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
        { label: 'Careers', to: '/careers' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Contact', to: '/contact' },
        { label: 'Help Center', to: '/help' },
      ]
    }
  ]
}

export const partnershipsPageFooter = {
  title: 'Partnership Application',
  subtitle: 'Start your journey',
  contactEmail: 'partnerships@mernaki.de',
  sections: [
    {
      title: 'Partnership',
      items: [
        { label: 'Partner Program', to: '/partners' },
        { label: 'About', to: '/about' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Contact', href: 'mailto:partnerships@mernaki.de' },
        { label: 'Help Center', to: '/help' },
      ]
    },
    {
      title: 'Legal',
      items: [
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Terms of Service', to: '/terms-of-service' },
      ]
    }
  ]
}

export const teamPageFooter = {
  title: 'Meet Our Team',
  subtitle: 'The people behind Mernaki',
  sections: [
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
        { label: 'Careers', to: '/careers' },
      ]
    },
    {
      title: 'Join Us',
      items: [
        { label: 'Open Positions', to: '/careers' },
        { label: 'Contact', to: '/contact' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'FAQ', to: '/faq' },
      ]
    }
  ]
}

export const bookingPageFooter = {
  title: 'Book a Service',
  subtitle: 'Schedule your consultation',
  sections: [
    {
      title: 'Services',
      items: [
        { label: 'View All Services', to: '/#services' },
        { label: 'Pricing', to: '/booking#pricing' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'Contact', to: '/contact' },
        { label: 'FAQ', to: '/faq' },
      ]
    },
    {
      title: 'Legal',
      items: [
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Terms of Service', to: '/terms-of-service' },
      ]
    }
  ]
}

export const helpCenterPageFooter = {
  title: 'How Can We Help?',
  subtitle: 'Find answers and support',
  sections: [
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'FAQ', to: '/faq' },
        { label: 'Contact', to: '/contact' },
        { label: 'Report Issue', to: '/report-issue' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Documentation', to: '/docs' },
        { label: 'API Reference', to: '/developer/api' },
        { label: 'Status', to: '/status' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
      ]
    }
  ]
}

export const faqPageFooter = {
  title: 'Frequently Asked Questions',
  subtitle: 'Quick answers to common questions',
  sections: [
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'Contact', to: '/contact' },
        { label: 'Report Issue', to: '/report-issue' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Documentation', to: '/docs' },
        { label: 'API Reference', to: '/developer/api' },
      ]
    },
    {
      title: 'Legal',
      items: [
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Terms of Service', to: '/terms-of-service' },
      ]
    }
  ]
}

export const documentationPageFooter = {
  title: 'Documentation',
  subtitle: 'Technical guides and references',
  sections: [
    {
      title: 'Docs',
      items: [
        { label: 'Getting Started', to: '/docs#getting-started' },
        { label: 'API Reference', to: '/developer/api' },
        { label: 'Examples', to: '/docs#examples' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'FAQ', to: '/faq' },
        { label: 'Contact', to: '/contact' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Status', to: '/status' },
        { label: 'Report Issue', to: '/report-issue' },
      ]
    }
  ]
}

export const apiReferencePageFooter = {
  title: 'API Reference',
  subtitle: 'Complete API documentation',
  sections: [
    {
      title: 'Documentation',
      items: [
        { label: 'Docs Home', to: '/docs' },
        { label: 'API Reference', to: '/developer/api' },
        { label: 'Examples', to: '/docs#examples' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'Report Issue', to: '/report-issue' },
        { label: 'Status', to: '/status' },
      ]
    },
    {
      title: 'Legal',
      items: [
        { label: 'Terms of Service', to: '/terms-of-service' },
        { label: 'Privacy Policy', to: '/privacy-policy' },
      ]
    }
  ]
}

export const statusPageFooter = {
  title: 'System Status',
  subtitle: 'Real-time service monitoring',
  sections: [
    {
      title: 'Status',
      items: [
        { label: 'Current Status', to: '/status' },
        { label: 'Incident History', to: '/status#history' },
        { label: 'Subscribe to Updates', to: '/status#subscribe' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'Report Issue', to: '/report-issue' },
        { label: 'Contact', to: '/contact' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Documentation', to: '/docs' },
        { label: 'API Reference', to: '/api-reference' },
      ]
    }
  ]
}

export const reportIssuePageFooter = {
  title: 'Report an Issue',
  subtitle: 'Help us improve',
  sections: [
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'FAQ', to: '/faq' },
        { label: 'Status', to: '/status' },
      ]
    },
    {
      title: 'Resources',
      items: [
        { label: 'Documentation', to: '/docs' },
        { label: 'Contact', to: '/contact' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
      ]
    }
  ]
}

export const servicePageFooter = {
  title: 'Our Services',
  subtitle: 'Comprehensive solutions',
  sections: [
    {
      title: 'Services',
      items: [
        { label: 'View All', to: '/#services' },
        { label: 'Booking', to: '/booking' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Help Center', to: '/help' },
        { label: 'Contact', to: '/contact' },
        { label: 'FAQ', to: '/faq' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
      ]
    }
  ]
}

export const privacyPolicyPageFooter = {
  title: 'Privacy Policy',
  subtitle: 'Your data, protected',
  sections: [
    {
      title: 'Legal',
      items: [
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Cookie Policy', to: '/cookies' },
        { label: 'Terms of Service', to: '/terms-of-service' },
        { label: 'Impressum', to: '/impressum' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Contact', to: '/contact' },
        { label: 'Help Center', to: '/help' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
      ]
    }
  ]
}

export const termsOfServicePageFooter = {
  title: 'Terms of Service',
  subtitle: 'Our agreement with you',
  sections: [
    {
      title: 'Legal',
      items: [
        { label: 'Terms of Service', to: '/terms-of-service' },
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Cookie Policy', to: '/cookies' },
        { label: 'Impressum', to: '/impressum' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Contact', to: '/contact' },
        { label: 'Help Center', to: '/help' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
      ]
    }
  ]
}

export const cookiePolicyPageFooter = {
  title: 'Cookie Policy',
  subtitle: 'How we use cookies',
  sections: [
    {
      title: 'Legal',
      items: [
        { label: 'Cookie Policy', to: '/cookies' },
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Terms of Service', to: '/terms-of-service' },
        { label: 'Impressum', to: '/impressum' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Contact', to: '/contact' },
        { label: 'Help Center', to: '/help' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
      ]
    }
  ]
}

export const impressumPageFooter = {
  title: 'Impressum',
  subtitle: 'Legal information',
  sections: [
    {
      title: 'Legal',
      items: [
        { label: 'Impressum', to: '/impressum' },
        { label: 'Privacy Policy', to: '/privacy-policy' },
        { label: 'Terms of Service', to: '/terms-of-service' },
        { label: 'Cookie Policy', to: '/cookies' },
      ]
    },
    {
      title: 'Support',
      items: [
        { label: 'Contact', to: '/contact' },
        { label: 'Help Center', to: '/help' },
      ]
    },
    {
      title: 'Company',
      items: [
        { label: 'About', to: '/about' },
        { label: 'Team', to: '/team' },
      ]
    }
  ]
}
